import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
  message,
} from "antd";

import moment from "moment";

import GenericTable from "../../components/Generic/Table";
import AddEditModal from "../../components/Generic/AddEditModal";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getData, loadMoreData } from "../../Redux/actions/crudActions";
import {
  getWeightedExchangeRate,
  calculateWeightedExchangeRate,
} from "../../Redux/actions/exchangerateActions";

import "./styles.scss";
import "./styles.css";

const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "exchangerate";

const PAGENAME = "Exchange Rate";

const MODAL_BLUEPRINT = [
  {
    title: "Rate",
    key: "rate",
    type: "number",
  },
  {
    title: "Amount",
    key: "amount",
    type: "number",
  },
];

const Index = (props) => {
  const [loading, setloading] = useState(true);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);
  const [currentWeighted, setCurrentWeighted] = useState(null);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount } = useSelector(
    (state) => ({
      crudData: state.crudReducer.data,
      crudDataCount: state.crudReducer.dataCount,
    }),
    shallowEqual
  );
  useEffect(() => {
    getcurrentrate();
  }, []);

  const getcurrentrate = async () => {
    var currentaverage = await dispatch(getWeightedExchangeRate());
    if (currentaverage) {
      setCurrentWeighted(currentaverage.value.toFixed(2));
    }
  };

  const setandcalculaterate = async () => {
    var newexrate = await dispatch(calculateWeightedExchangeRate());
    if (newexrate) {
      setCurrentWeighted(newexrate);
      message.info("weighted exchange rate changed");
    }
  };

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setModalMode("edit");
    setCurrentSelected(value);
  };

  const columns = [
    {
      title: "date",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "exchange rate",
      dataIndex: "rate",
      key: "rate",
    },
    {
      title: "amount",
      dataIndex: "amount",
      key: "amount",
    },
  ];

  return (
    <div className="maindiv">
      <div className={"generic_container"}>
        <PageHeader
          title={PAGENAME + "s"}
          subTitle={
            <div className={"header"}>
              {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
            </div>
          }
          extra={
            <div className={"header"}>
              {/* <UserModal headername={PAGENAME} currentItem={currentSelected} 
                        modalMode={modalMode} blueprint={MODAL_BLUEPRINT} apiurl={API_URL} 
                        token={props.session.access}
                        onModalClose={(action)=>{
                          setCurrentSelected(null);
                          if(action =='reset'){setResetTable(!resetTable)}
                        }}                     
                      /> */}
              <span>
                <h1>weighted average: {currentWeighted}</h1>
              </span>
              <AddEditModal
                headername={PAGENAME}
                currentItem={currentSelected}
                modalMode={modalMode}
                blueprint={MODAL_BLUEPRINT}
                apiurl={API_URL}
                onModalClose={(action) => {
                  setModalMode("add");
                  setCurrentSelected(null);
                  if (action == "reset") {
                    setResetTable(!resetTable);
                    setandcalculaterate();
                  }
                }}
              />

              {crudDataCount > 0 ? (
                <Button
                  type={"primary"}
                  shape={"round"}
                  onClick={() => {
                    dispatch(loadMoreData());
                  }}
                  style={{ marginRight: "1em" }}
                >
                  Load More
                </Button>
              ) : null}

              <Button
                onClick={() => {
                  setResetTable(!resetTable);
                }}
                className="button"
              >
                <ReloadOutlined />
              </Button>
            </div>
          }
        ></PageHeader>
        <div className={"content_container"}>
          <GenericTable
            ref={tableRef}
            apiurl={API_URL}
            columns={columns}
            mainSearch={mainSearch}
            resetTable={resetTable}
            ChangedSelected={(selected) => {
              itemSelected(selected);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
